import { markAsReadNotificationApi,getNotificationDataApi } from '@/modules/notifications/infrastructure/NotificationUseCase';
import { getField, updateField } from 'vuex-map-fields';

const state = {
    notifications: []
  };
  
const getters = {
    getField,
    allNotifications: state => state.notifications
};


const addNotification = ({ commit }, notification) => {
    commit('ADD_NOTIFICATION', notification);
}
const removeNotification = async ({ commit }, {user_id,noti_id}) => {
    await markAsReadNotificationApi().run(user_id,noti_id)
            .then((response) => {
                commit('REMOVE_NOTIFICATION', noti_id);
            })
            .catch(error => {
                console.error('Error removing notification:', error);
                });
    
}
const fetchNotifications = ({ commit }) => {
    return getNotificationDataApi().execute()
        .then(data => {
            commit('SET_NOTIFICATIONS', data);
        })
        .catch(error => {
        console.error('Error fetching notifications:', error);
        });
    }

const actions = {
    addNotification,
    removeNotification,
    fetchNotifications,
}
  
const mutations = {
    updateField,
    ADD_NOTIFICATION(state, notification) {
        state.notifications.push(notification);
    },
    REMOVE_NOTIFICATION(state, notificationId) {
        state.notifications = state.notifications.filter(
        notification => notification.id !== notificationId
        );
    },
    SET_NOTIFICATIONS(state,notifications) {
        state.notifications = notifications;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};